/** ******* 以下为折线图配置 ********** */

/** ******* 以下为饼图配置 ************ */

export const SUMMARY_GRAPHIC_ID = 'summaryValue';

// 水平图例高度
export const HORIZONTAL_LEGEND_HEIGHT = 12;

// 垂直图例宽度
export const VERTICAL_LEGEND_WIDTH = 20;
// 垂直图例距离画布的边距
export const VERTICAL_LEGEND_MARGIN = 5;
// 垂直图例距离饼图的边距
export const VERTICAL_LEGEND_GAP = 5;

export const VERTICAL_CHART_MARGIN =
  VERTICAL_LEGEND_WIDTH + VERTICAL_LEGEND_MARGIN + VERTICAL_LEGEND_GAP;

export const CENTER_TITLE_LINE_HEIGHT = 12;
export const CENTER_CONTENT_LINE_HEIGHT = 24;

// 外层radius默认百分比:https://echarts.apache.org/zh/option.html#series-pie.radius
export const DEFAULT_OUTER_RADIUS = 0.8;
export const SPIDER_OUTER_RADIUS = 0.65;

export const SCROLL_BAR_HEIGHT = 16;

export const BASE_DATA_ZOOM_CONFIG = {
  type: 'slider',
  brushSelect: false,
  showDetail: false,
  filterMode: 'filter',
  zoomLock: true,
  start: 0,
  end: 50,
  height: SCROLL_BAR_HEIGHT,
  bottom: 0,
};

export const STATISTIC_CARD_BG_COLORS = [
  {
    label: '#F6F7FC',
    value: '#F6F7FC',
  },
  {
    label: '#ECFAF2',
    value: '#ECFAF2',
  },
  {
    label: '#FDF1F3',
    value: '#FDF1F3',
  },
  {
    label: '#FEF8E2',
    value: '#FEF8E2',
  },
  {
    label: '#DEF1FD',
    value: '#DEF1FD',
  },
  {
    label: '#F7F0FE',
    value: '#F7F0FE',
  },
  {
    label: '#F2F2F6',
    value: '#F2F2F6',
  },
];

export const INTERVAL_LABEL_MAP = {
  max: [
    {
      name: '最大值',
      type: 'max',
    },
  ],
  min: [
    {
      name: '最小值',
      type: 'min',
    },
  ],
  maxAndMin: [
    {
      name: '最大值',
      type: 'max',
    },
    {
      name: '最小值',
      type: 'min',
    },
  ],
};
